module.exports = __webpack_public_path__ + "img/20190824114602716.8db2d0e0.jpg";